import { useSelector } from 'react-redux'
import { useMemo } from 'react'

import { getTotalBudgetInDigitalRight } from '../../../helpers/other'
import { calculateImpressionsFromBudget } from './ImpressionsBudgetSection/helpers'

import { combinedCampaignsSelector } from '../../../modules/selectors/combinedData'
import { rightSelector } from '../../../modules/selectors/rights'

const useRightBudgetAndImpressionsCalculation = () => {
  const combinedCampaigns = useSelector(combinedCampaignsSelector)
  const right = useSelector(rightSelector)

  const { allocation: impressionAllocationOnDigitalRight, budget: rightBudget, bid_cap: rightBidCap } = right

  const { campaigns = [] } = combinedCampaigns

  // budget
  const rightTotalBudget = useMemo(() => {
    return getTotalBudgetInDigitalRight(campaigns)
  }, [campaigns])

  // impressions
  const rightTotalImpressions = useMemo(() => {
    return calculateImpressionsFromBudget({
      budget: rightTotalBudget,
      rightBidCap
    })
  }, [rightTotalBudget, rightBidCap])

  const remainingBudget = useMemo(() => {
    return rightBudget - rightTotalBudget
  }, [rightBudget, rightTotalBudget])

  const remainingImpressions = impressionAllocationOnDigitalRight - rightTotalImpressions

  return useMemo(
    () => ({
      remainingBudget,
      remainingImpressions
    }),
    [remainingBudget, remainingImpressions]
  )
}

export default useRightBudgetAndImpressionsCalculation
